namespace e5 {
    export interface ArrayBufferLoaderOptions extends AjaxLoaderOptions {

    }

    class ArrayBufferLoader extends AbstractAjaxLoader<ArrayBuffer, ArrayBufferLoaderOptions>{
        protected defaultOptions(): ArrayBufferLoaderOptions {
            return {
                decoder: "arraybuffer"
            }
        }
    }

    export interface LoaderOptionsMap {
        "arraybuffer": ArrayBufferLoaderOptions;
    }

    export interface LoaderMap {
        "arraybuffer": ArrayBufferLoader;
    }

    registerLoader("arraybuffer", ArrayBufferLoader);
}